import ActionBase, { ACTION_TYPES } from './ActionBase.js';
import Store from '../../Store.js';

/**
 * @module Core/data/stm/action/AddAction
 */

/**
 * Action to record the fact of models adding to a store.
 * @extends Core/data/stm/action/ActionBase
 */
export default class AddAction extends ActionBase {
    static $name = 'AddAction';

    static configurable = {
        /**
         * Reference to a store that models have been added into.
         *
         * @prp {Core.data.Store}
         * @readonly
         * @default
         */
        store : undefined,

        /**
         * List of models added into the store.
         *
         * @prp {Core.data.Model[]}
         * @readonly
         * @default
         */
        modelList : undefined,

        /**
         * Flag showing if undo/redo should be done silently i.e. with events suppressed
         *
         * @prp {Boolean}
         * @readonly
         * @default
         */
        silent : false
    };

    get type() {
        return ACTION_TYPES.ADD;
    }

    //<debug>
    afterConfig() {
        super.afterConfig();

        console.assert(
            this.store instanceof Store &&
            Array.isArray(this.modelList) &&
            this.modelList.length &&
            this.modelList.every(m => m.isModel),
            "Can't create action, bad configuration!"
        );
    }
    //</debug>

    changeStore(store) {
        //<debug>
        console.assert(
            !this._store && store && store instanceof Store,
            "Can't set store, store is required and can be set only once!"
        );
        //</debug>

        return store;
    }

    changeModelList(list) {
        //<debug>
        console.assert(
            !this._modelList &&
            Array.isArray(list) &&
            list.length,
            list.every(m => m.isModel),
            "Can't set model list, model list is required it should be array of Models and it can be set only once!"
        );
        //</debug>

        return list.slice(0);
    }

    undo() {
        this.store.remove(this.modelList, this.silent);
    }

    redo() {
        this.store.add(this.modelList, this.silent);
    }
}
